import type { IAddress } from '@/interfaces'
import type { IUser } from '@/interfaces/IUser'

class User implements IUser {
  id: string

  initials: string

  userName: string

  name: string

  email: string

  phoneNumber: string

  roles: string[]

  designation: string

  hourlyRate: number

  address: IAddress

  constructor(user?: any) {
    this.id = user?.id
    this.initials = user?.initials
    this.userName = user?.userName
    this.name = user?.name
    this.email = user?.email
    this.phoneNumber = user?.phoneNumber
    this.roles = user?.roles
    this.designation = user?.designation
    this.hourlyRate = user?.hourlyRate
    this.address = user?.address
  }
}

export default User
